<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">处理</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="">

        <el-form :model="dealFrom" :rules="rules" ref="dealForm">
          <div>
            <el-row>
              <el-col :span="24" class="item">
                <el-form-item label="报警人">
                  <el-input v-model="elderlyName" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="item">
                <el-form-item label="处理记录" required prop="dealMessage">
                  <el-input v-model="dealFrom.dealMessage" type="textarea" rows="5"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('dealForm')">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: 'Deal',
  props: [],
  data() {
    return {

      loading: false,

      dealFrom:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        dealMessage:'',
        status:1,
        lessBalanceCode:'',
      },
      rules:{
        dealMessage:[
          { required: true, message: '请输入处理结果', trigger: 'blur' },
          { required: true, message: '请输入处理结果', trigger: 'change' },
        ],
      },

      elderlyName:'',

    }
  },

  methods: {

    init(lessBalanceCode,elderlyName){

      this.$refs.dealForm.resetFields();
      this.dealFrom.lessBalanceCode=lessBalanceCode;

      this.elderlyName = elderlyName;

    },

    closeSelf() {
      this.$emit("closeDeal");
    },

    confirm(dealForm){
      this.$refs[dealForm].validate((valid) => {
        if (valid) {
          this.addSubmit()
        } else {
          console.log('error submit!!');
          return false;
        }
      });




    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.dealFrom.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"LessBalance/Edit",
        data: this.dealFrom,
      }).then(
          (response) => {
            //console.log(response);
            this.loading = false;

            if (response.data.error == 0) {
              this.$emit("closeDeal");
              this.$emit("getList",false);
            } else {
              this.$message({type: 'info', message: response.data.message});
            }

          }
      )
    },


  }
}


</script>





<style lang="scss" scoped>


</style>
